import { render, staticRenderFns } from "./UserSessions.vue?vue&type=template&id=2b4e952e&scoped=true"
import script from "./UserSessions.vue?vue&type=script&lang=js"
export * from "./UserSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e952e",
  null
  
)

export default component.exports